<template>
  <div>
    <div class="idb-block">
      <div class="idb-block-title">
        <h2>Submission History<favourite-icon></favourite-icon></h2>
      </div>
      <div class="idb-block-content">
        <vue-good-table
          mode="remote"
          ref="table"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          @on-row-click="onRowChange"
          :rows="rows"
          :lineNumbers="true"
          :totalRows="totalRecords"
          :search-options="{
              enabled: true
              }"
          :paginationOptions="paginationOptions"
          :sort-options="sortOptions"
          :isLoading.sync="isTableLoading"
          styleClass="vgt-table striped bordered"
          :columns="columns"
        >
          <template slot="loadingContent">
            <h1>Loading...</h1>
          </template>
          <div slot="emptystate">
            <div class="vgt-center-align vgt-text-disabled">No data available</div>
          </div>
          <div slot="table-actions">
            <button
              @click.prevent="clearTableFilters"
              class="btn btn-link"
              v-b-popover.hover.top.d500="'Clear filters'"
            >
              <span class="fa-stack" style="font-size: 10px;">
                <i class="fa fa-filter fa-stack-1x dimmedIcon"></i>
                <i class="fa fa-ban fa-stack-2x dimmedIcon"></i>
              </span>
            </button>
            <b-button
              @click.prevent="load" :disabled="isLoading"
              class
              variant="link"
              v-b-popover.hover.top.d500="'Refresh the data in the table'"
            >
              <i class="fa fa-sync pointer dimmedIcon"></i>
            </b-button>
          </div>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import tableFilterMixin from '@/Assets/Mixins/TableFilterMixin'
  import loading from '@/Assets/Mixins/LoadingMixin'
  import {mapGetters} from "vuex";
  import roles from "@/Assets/Constants/roles";
  export default {
    mixins: [tableFilterMixin, loading],
    data () {
      return {
        rows: [],
        creditSun: true,
        serverParams: {
          sort: [{ field: 'createdDate', type: 'desc' }]
        },
        columns: [
          {
            label: 'id',
            field: 'submissionId',
            hidden: true
          },
          {
            label: 'Submission Date',
            field: 'createdDate',
            formatFn: this.formatDate
          },
          {
            label: 'Collection Date',
            field: 'collectionDate',
            formatFn: this.formatDate
          },
          {
            label: 'Payment Date',
            field: 'paymentDate',
            formatFn: this.formatDate
          },
          {
            label: 'Settlement Date',
            field: 'settlementDate',
            formatFn: this.formatDate
          },
          {
            label: 'Instruction Count',
            field: 'instructionCount'
          },
          {
            label: 'Debit Amount',
            field: 'debitValue',
            formatFn: this.formatAmount
          },
          {
            label: 'Credit Amount',
            field: 'creditValue',
            formatFn: this.formatAmount,
            hidden: true
          },
          {
            label: 'Indemnity Count',
            field: 'indemnityCount'
          },
          {
            label: 'Indemnity Value',
            field: 'indemnityValue',
            formatFn: this.formatAmount
          }
        ]
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      load: async function () {
        try {
          var response = await axios.get(`${process.env.VUE_APP_DDMS_API_URL}indemnitysubmissions`, { params: { ...this.buildGoodTableQuery(), paygateId: this.paygateId } })
          if (response) {
            this.rows = response.data.data
            this.totalRecords = response.data.count
            this.creditSun = response.data.canCredit
            this.$set(this.columns[7], 'hidden', !this.hasRefunds)
          }
        } catch (error) {
          this.$toastr.e(error)
        }
      },
      onRowChange (e) {
        console.log(e)
        this.$router.push({ path: `/collections/submissionhistory/${e.row.submissionId}` })
      },
      pad (num, size) {
        var s = '00' + num
        return s.substr(s.length - size)
      },
      numberWithCommas (x) {
        x = x.toString()
        var pattern = /(-?\d+)(\d{3})/
        while (pattern.test(x)) {
          x = x.replace(pattern, '$1,$2')
        }
        return x
      },
      formatAmount (value) {
        return '£' + this.numberWithCommas((value / 1).toFixed(2))
      },
      formatStatus (value) {
        let retVal = ''
        switch(value) {
          case 1:
            retVal = 'Created'
            break
          case 2:
            retVal = 'In Progress'
            break
          case 3:
            retVal = 'Resolved'
            break
          case 4:
            retVal = 'Rejected'
            break
          case 5:
            retVal = 'Action Required'
            break
          default:
            retVal = 'None'
            break
        }
        return retVal
      },
      formatDate (date) {
        if (!date.getDate) {
          date = new Date(date)
        }
        var day = date.getDate()
        var monthIndex = date.getMonth() + 1
        var year = date.getFullYear()
        return `${this.pad(day, 2)}/${this.pad(monthIndex, 2)}/${year}`
      }
    },
    computed:{
      ...mapGetters(['selectedCustomer']),
      hasRefunds () {
        return this.$store.getters.hasLicence('LicenceCollectionsRefunds') && this.creditSun
      },
    },
    watch: {
      selectedCustomer () {
        this.load()
      }
    },
    async beforeRouteLeave (to, from, next) {
      await this.clearTableFilters()
      next()
    }
  }
</script>
